import roundAbnt from './roundAbnt';

const formatNumberToCurrencyNoSymbol = (value: number): string => {
  return roundAbnt(value).toLocaleString('pt-Br', {
    minimumFractionDigits: 2,
  });
};

export default formatNumberToCurrencyNoSymbol;
